var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item d-flex flex-column justify-content-center align-items-center"},[_c('img',{staticClass:"flex-shrink-0",attrs:{"src":_vm.item.img}}),_c('div',{staticClass:"content i_mt_2"},[_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.item.title))]),_c('p',{staticClass:"i_body_l"},[_vm._v(_vm._s(_vm.item.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }